/** px to rem (16px root), for sizes computed in code: sizes follow the reader's font-size setting. */
export const rem = (px: number): string => `${Math.round((px / 16) * 10000) / 10000}rem`;
